<template>
  <li class="labeled-list__item">
    <LabeledContent>
      <Headline slot="headline" v-editable.text="resource.columns.title" :size="1" />
      <component :is="blockName(child)" v-for="child in resource.children" :key="child.id" :resource="child" />
    </LabeledContent>
  </li>
</template>

<script>
import LabeledContent from 'beisheim/components/elements/labeled-content'
import LabeledListMedia from 'beisheim/components/blocks/labeled-list-media'
import LabeledListText from 'beisheim/components/blocks/labeled-list-text'
import Unknown from "@i22/frontend-cms-utils/components/unknown";
import Headline from 'beisheim/components/elements/headline'
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  components: {
    LabeledContent,
    LabeledListMedia,
    LabeledListText,
    Unknown,
    Headline
  },
  mixins: [ editable ],
  methods: {
    blockName (resource) {
      if (!Object.keys(this.$options.components).includes(resource.resource_class_name)) { return 'Unknown' }
      return resource.resource_class_name
    }
  }
}
</script>
